import { useState, useEffect } from "react";

export function useLang() {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  useEffect(() => {
    const handler = (e) => setLang(e.detail);
    window.addEventListener("langChange", handler);
    return () => window.removeEventListener("langChange", handler);
  }, []);

  return lang;
}

const translations = {
  fr: {
    // ── Navigation ──
    accueil: "Accueil",
    quiSommesNous: "Qui sommes-nous",
    nosServices: "Nos services",
    news: "News",
    contact: "Contact",
    admin: "Admin",

    // ── Auth ──
    connexion: "Connexion",
    sInscrire: "S'inscrire",
    monProfil: "Mon profil",
    parametres: "Paramètres",
    deconnexion: "Déconnexion",

    // ── Accueil ──
    bienvenue: "Bienvenue",
    heroSub: "Retrouvez toutes les informations sur nos services. Plusieurs solutions, une seule équipe.",
    nosServicesBtn: "NOS SERVICES →",
    quiSommesNousBtn: "QUI SOMMES-NOUS ?",
    bientotDisponible: "🔒 Bientôt disponible",
    decouvrir: "Découvrir bientôt →",

    // ── News ──
    actualites: "Actualités",
    newsTitle: "📢 News",
    voirDetails: "VOIR LES DÉTAILS →",
    voirAbonnements: "VOIR LES ABONNEMENTS →",
    aucuneInfo: "Aucune information pour le moment.",
    masquerDetails: "Masquer les détails",

    // ── Contact ──
    onVousEcoute: "On vous écoute",
    nousContacter: "Nous contacter",
    uneQuestion: "Une question ? Écrivez-nous directement.",
    nom: "Nom",
    email: "Email",
    objet: "Objet",
    message: "Message",
    envoyer: "Envoyer le message ✉️",
    envoi: "Envoi en cours…",
    successMsg: "✅ Message envoyé ! Nous vous répondrons rapidement.",
    errorMsg: "❌ Erreur lors de l'envoi. Réessayez ou contactez-nous par téléphone.",
    envoyerUnMessage: "Envoyer un message",
    reponse24h: "Réponse sous 24h",
    lunVen: "Lun – Ven, 9h – 18h",
    voirNotrePage: "Voir notre page →",

    // ── Qui sommes-nous ──
    notreHistoire: "Notre histoire",
    quiTitre: "Qui sommes-nous ?",
    quiIntro: "Bienvenue chez Starting Five — Notre groupe propose différents services pour répondre à vos besoins.",
    quiTexte1: "STARTING 5 est né de l'ambition commune de cinq togolais déterminées à construire bien plus qu'un simple projet : une vision durable tournée vers l'avenir du Togo. Répartis entre l'Afrique, l'Europe et l'Amérique, nous partageons la même volonté : créer des services utiles capables de simplifier le quotidien.",
    quiTexte2: "Notre aventure débute aujourd'hui et tout est pensé pour faciliter la vie des usagers togolais, en leur offrant des solutions simple, moderne et sans contraintes.",
    quiTexte3: "Nos idées sont nées presque par hasard, un été où nous nous sommes retrouvés face à des problématiques du quotidien. Nous avons alors décidé d'y répondre à notre façon. Comme quoi, les plus grands projets commencent parfois avec les situations les plus simples.",
    mission: "Notre mission",
    missionText: "Offrir des services de qualité adaptés à chaque besoin.",
    vision: "Notre vision",
    visionText: "Être la référence dans notre domaine à l'échelle nationale.",
    valeurs: "Nos valeurs",
    valeursText: "Simplicité, excellence, accessibilité et engagement.",

    // ── Nos Services (teasing) ──
    servicesBientot: "Nos services • Bientôt",
    servicesHero: "Quelque chose se prépare.",
    servicesHeroSub: "Nos services sont en cours de finalisation. En attendant, voici un avant-goût de ce qui vous attend.",
    resteConnecte: "Restez connectés",
    resteConnecteSub: "Le lancement approche. Suivez nos actualités pour ne rien manquer.",
    // Wash Bros
    washBrosTagline: "Des frères qui lavent?",
    washBrosDesc: "Peut être que c'est un carwash, ou un pressing, On verra bien !",
    // Zamenoulli
    zamenoulliTagline: "Vous allez grave aimer",
    zamenoulliDesc: "On dirait une marque italienne ça pourrait faire référence à un resto...",
    // WhoWe
    whoWeTagline: "Un projet révolutionnaire et ambitieux",
    whoWeDesc: "J'arrive pas à savoir... c'est surement un magasin de plantes verte, qui sait?",

    // ── Footer ──
    footerDesc: "Five Spirits, One vision, No limit.",
    navigation: "Navigation",
    politiqueCookies: "Politique de cookies",
    aPropos: "À propos",
    cgu: "CGU",
    confidentialite: "Confidentialité",
    copyright: "© 2026 Starting Five — Tous droits réservés.",
  },

  en: {
    // ── Navigation ──
    accueil: "Home",
    quiSommesNous: "About us",
    nosServices: "Our services",
    news: "News",
    contact: "Contact",
    admin: "Admin",

    // ── Auth ──
    connexion: "Login",
    sInscrire: "Sign up",
    monProfil: "My profile",
    parametres: "Settings",
    deconnexion: "Logout",

    // ── Accueil ──
    bienvenue: "Welcome",
    heroSub: "Find all information about our services. Multiple solutions, one team.",
    nosServicesBtn: "OUR SERVICES →",
    quiSommesNousBtn: "ABOUT US",
    bientotDisponible: "🔒 Coming soon",
    decouvrir: "Discover soon →",

    // ── News ──
    actualites: "News",
    newsTitle: "📢 News",
    voirDetails: "SEE DETAILS →",
    voirAbonnements: "SEE SUBSCRIPTIONS →",
    aucuneInfo: "No information at the moment.",
    masquerDetails: "Hide details",

    // ── Contact ──
    onVousEcoute: "We're listening",
    nousContacter: "Contact us",
    uneQuestion: "A question? Write to us directly.",
    nom: "Name",
    email: "Email",
    objet: "Subject",
    message: "Message",
    envoyer: "Send message ✉️",
    envoi: "Sending…",
    successMsg: "✅ Message sent! We will get back to you shortly.",
    errorMsg: "❌ Error while sending. Retry or contact us by phone.",
    envoyerUnMessage: "Send a message",
    reponse24h: "Reply within 24h",
    lunVen: "Mon – Fri, 9am – 6pm",
    voirNotrePage: "View our page →",

    // ── Qui sommes-nous ──
    notreHistoire: "Our story",
    quiTitre: "Who are we?",
    quiIntro: "Welcome to Starting Five — our group offers various services to meet your needs.",
    quiTexte1: "STARTING 5 was born from the shared ambition of five determined Togolese people to build far more than a simple project: a lasting vision for the future of Togo. Spread across Africa, Europe and America, we share the same drive: creating useful services that simplify everyday life.",
    quiTexte2: "Our adventure starts today and everything is designed to make life easier for Togolese users, offering them simple, modern and hassle-free solutions.",
    quiTexte3: "Our ideas came about almost by chance, one summer when we found ourselves facing everyday problems. We then decided to tackle them our own way. As they say, the greatest projects sometimes start from the simplest situations.",
    mission: "Our mission",
    missionText: "Deliver quality services tailored to every need.",
    vision: "Our vision",
    visionText: "Become the benchmark in our field nationally.",
    valeurs: "Our values",
    valeursText: "Simplicity, excellence, accessibility and commitment.",

    // ── Nos Services (teasing) ──
    servicesBientot: "Our services • Coming soon",
    servicesHero: "Something is coming.",
    servicesHeroSub: "Our services are being finalized. In the meantime, here's a taste of what's coming.",
    resteConnecte: "Stay connected",
    resteConnecteSub: "The launch is approaching. Follow our news to stay updated.",
    // Wash Bros
    washBrosTagline: "Brothers who wash?",
    washBrosDesc: "Maybe it's a carwash, or a laundry, we'll see!",
    // Zamenoulli
    zamenoulliTagline: "You're gonna love it",
    zamenoulliDesc: "Sounds like an Italian brand, could be a restaurant...",
    // WhoWe
    whoWeTagline: "A revolutionary and ambitious project",
    whoWeDesc: "Can't figure it out... probably a plant shop, who knows?",

    // ── Footer ──
    footerDesc: "Five Spirits, One vision, No limit.",
    navigation: "Navigation",
    politiqueCookies: "Cookie policy",
    aPropos: "About",
    cgu: "Terms of Use",
    confidentialite: "Privacy",
    copyright: "© 2026 Starting Five — All rights reserved.",
  },
};

export function useT() {
  const lang = useLang();
  return (key) => translations[lang]?.[key] ?? translations["fr"][key] ?? key;
}